<svg width="10" height="10" viewBox="0 0 10 10" fill="none">
    <path
        d="M1.40022 8.60034L8.60022 1.40034"
        stroke="#393939"
        stroke-linecap="round"
        stroke-linejoin="round"
    />
    <path
        d="M8.60027 8.60034L1.40027 1.40034"
        stroke="#393939"
        stroke-linecap="round"
        stroke-linejoin="round"
    />
</svg>
